import script from "./ListarAulasAvulsas.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarAulasAvulsas.vue?vue&type=script&setup=true&lang=js"

import "./ListarAulasAvulsas.vue?vue&type=style&index=0&id=e5ad7210&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5ad7210"]])

export default __exports__